export const CHAT_TOAST_POSITION = 'bottom-right' as const;

/** Clears Sonner's default wrapper border/padding/shadow so only the inner card renders. */
export const CHAT_TOAST_WRAPPER_STYLE = {
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
  padding: 0,
} as const;
